React = require 'react'
{ PropTypes } = React
{ connect } = require 'react-redux'
{ fetchSchools, selectSchool } = require '../actions/schools'
{ fetchClassroomsBySchool } = require '../actions/classrooms'
SelectSchoolComponent = require '../components/SelectSchool'

SelectSchool = React.createClass
	displayName: 'SelectSchool'
	propTypes:
		disabled: PropTypes.bool
		schools: PropTypes.array
		feedback: PropTypes.object
		fetchClassroomsBySchool: PropTypes.func.isRequired,
		fetchSchools: PropTypes.func.isRequired
		isFetching: PropTypes.bool
		reduxFormProps: PropTypes.object
		selectedDistrict: PropTypes.object
		selectedSchool: PropTypes.object
		selectSchool: PropTypes.func.isRequired
		# If this component shouldn't be responsible for fetching schools, set `shouldFetchSchools` to false.
		# Defaults to true.
		shouldFetchSchools: PropTypes.bool
		# If this component should be responsible for fetching classrooms, set `shouldFetchClassrooms` to true.
		# Defaults to false.
		shouldFetchClassrooms: PropTypes.bool

	componentWillMount: ->
		unless @props.schools?.length || @props.shouldFetchSchools == false
			@props.fetchSchools()

	render: ->
		React.createElement(SelectSchoolComponent, { \
			"disabled": ( @props.disabled ),  \
			"schools": ( @props.schools ),  \
			"feedback": ( @props.feedback ),  \
			"fetchClassroomsBySchool": ( @props.fetchClassroomsBySchool ),  \
			"isFetching": ( @props.isFetching ),  \
			"reduxFormProps": ( @props.reduxFormProps ),  \
			"selectedDistrictId": ( @props.selectedDistrict?.id ),  \
			"selectedSchoolId": ( @props.selectedSchool?.id ),  \
			"selectSchool": ( @props.selectSchool ),  \
			"shouldFetchClassrooms": ( @props.shouldFetchClassrooms )
		})

mapStateToProps = (state) ->
	isFetching: state.schools.isFetching
	schools: state.schools.list
	selectedDistrict: state.districts.selected
	selectedSchool: state.schools.selected

mapDispatchToProps = {
	fetchClassroomsBySchool
	fetchSchools
	selectSchool
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(SelectSchool)



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/a2i/js/containers/SelectSchool.cjsx